/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(['jquery', 'assets/js/modules/View', 'Handsontable'], function($, View, Handsontable) {
    return View.extend({
        initialize: function(options) {
            this.table = options.table;
            this.$loading = this.$el.find('.mailing-list-items-table-overlay');

            this.initHandsontable(options.data);
        },

        initHandsontable: function(data) {
            this.getTableElement().handsontable({
                data: data,
                height: 400,
                rowHeaders: true,
                stretchH: 'all'
            });
        },

        loadData: function(data) {
            this.getTableElement().handsontable('loadData', data);
        },

        render: function() {
            this.getTableElement().handsontable('render');
        },

        isRedoAvailable: function() {
            return this.getTableElement().handsontable('isRedoAvailable');
        },

        isUndoAvailable: function() {
            return this.getTableElement().handsontable('isUndoAvailable');
        },

        undo: function() {
            this.getTableElement().handsontable('undo');
        },

        redo: function() {
            this.getTableElement().handsontable('redo');
        },

        clearHistory: function() {
            this.getTableElement()
                .handsontable('getInstance')
                .undoRedo.clear();
        },

        getTableElement: function() {
            return this.$el.find(this.table);
        }
    });
});
